import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';

import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';

import { UserConstants } from '../../constants/user.constants';
import { LoaderService } from '../../core/loader/loader.service';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  constructor(public loaderService: LoaderService) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    if (
      !request.url.includes('/portal/devices/') &&
      !request.url.includes('/summary/device-statuses') &&
      !request.url.includes(UserConstants.USER_PROFILE_IMAGE_KEY)
    ) {
      this.loaderService.showLoader();
    }

    return next.handle(request).pipe(
      finalize(() => {
        if (
          !request.url.includes('/portal/devices/') &&
          !request.url.includes('/summary/device-statuses') &&
          !request.url.includes(UserConstants.USER_PROFILE_IMAGE_KEY)
        ) {
          this.loaderService.hideLoader();
        }
      })
    );
  }
}
